<template>
  <div class="image-page">
    <div v-for="(item, index) of imgList" class="img-box" :key="item" @click="handleImgBtnClick(imgList, index)">
      <div class="delete-btn" @click.stop="onDeleteUploadImgClick(index)">
        <van-icon font="18" class="delete-icon" :name="require('../../../assets/imgs/ic_img_delete.png')" />
      </div>
      <van-image
        class="img-show"
        width="72"
        height="72"
        alt="图片"
        :src="ossResize ? `${item}${ossResizeQuery}` : item"
      >
        <template v-slot:loading>加载中...</template>
      </van-image>
    </div>

    <template v-if="canShowUploadBtn" style="display: inline-block">
      <van-uploader
        class="upload-btn"
        :deletable="true"
        :after-read="afterRead"
        :beforeRead="beforeRead"
        accept="image/*"
      >
        <div class="image-btn-box">
          <van-icon class="icon-tip" size="24" :name="require('@/assets/imgs/photo.png')" />
          <p class="tip">上传凭证</p>
          <p class="tip">（最多3张）</p>
        </div>
      </van-uploader>
    </template>

    <van-image-preview v-model="showPreView" :images="imgList"></van-image-preview>
  </div>
</template>
<script>
import ImageButton from '@/components/ImageButton.vue';

export default {
  components: {
    ImageButton
  },
  props: {
    limit: {
      type: Number,
      default: 1
    },
    picSize: {
      type: Number,
      default: 10240 * 1024
    },
    ossResize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      imgList: [],
      ossResizeQuery: '?x-oss-process=image/resize,m_fill,w_72,h_72',
      showPreView: false
    };
  },
  computed: {
    canShowUploadBtn() {
      return this.imgList.length < this.limit;
    }
  },
  methods: {
    beforeRead(inputFiles) {
      let files = [];
      if (!Array.isArray(inputFiles)) {
        files = [inputFiles];
      }
      if (files.some((file) => !/[jpg|jpeg|png]$/i.test(file.name))) {
        this.$toast('只支持png,jpg图片格式');
        return false;
      }
      if (files.some((file) => file.size > this.picSize)) {
        this.$toast('单张图片不能超过10m');
        return false;
      }
      return true;
    },

    afterRead(files) {
      this.uploadFile(files);
    },

    uploadFile({ file }) {
      const formData = new FormData();
      formData.append('action', 'fileUpload');
      formData.append('file', file);
      // dispatchUsploadImg(this.$store, formData)
      this.$fetch
        .uploadFile(formData)
        .then((resData = {}) => {
          const { fileUrl = '', data = {} } = resData;
          if (data.fileUrl) {
            this.imgList.push(data.fileUrl);
            this.emitImageChanged();
          } else {
            this.$toast('上传失败，请重试');
          }
        })
        .catch(() => {
          this.$toast('上传失败，请重试');
        });
    },

    onDeleteUploadImgClick(index) {
      this.imgList.splice(index, 1);
      this.emitImageChanged();
    },

    emitImageChanged() {
      this.$emit('handleImageChange', this.imgList);
    },

    handleImgBtnClick(imgs, index) {
      ImagePreview({
        images: imgs,
        startPosition: index
      });
    },
    async onAppUploadClick() {
      const data = await this.adapter.chooseSingleImage();
      if (data.url) {
        this.imgList.push(data.fullPath);
        this.emitImageChanged();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.image-page {
  display: flex;
  .upload-img {
    float: none;
  }
  .img-box {
    position: relative;
    display: inline-block;
    margin-right: 12px;
    border-radius: 4px;
    width: 72px;
    height: 72px;
    .delete-btn {
      width: 18px;
      height: 18px;
      position: absolute;
      right: -9px;
      top: -9px;
      background: transparent;
      border-radius: 0 0 0 12px;
      z-index: 100;
      .delete-icon {
        color: #fff;
        font-size: 18px;
      }
    }
    .img-show {
      border-radius: 4px;
      overflow: hidden;
    }
  }
  .image-btn-box {
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon-tip {
      margin-bottom: 2px;
      height: 24px;
    }
    .tip {
      color: #8c8c8c;
      font-size: 10px;
      line-height: 13px;
      width: 56px;
      text-align: center;
    }
  }
  .upload-btn {
    border: 1px dashed #bfbfbf;
    height: 72px;
    border-radius: 4px;

    ::v-deep.image-box {
      background: #f9faf9;
    }
  }
}
</style>
